// extracted by mini-css-extract-plugin
module.exports = {"text":"typography-TextShell-text-a647b5ac"};